export const todo = (message) => {
    throw Error('todo' + (message ? `: ${message}` : ''));
};
export const assert = (condition, message) => {
    if (!condition) {
        throw Error('assertion failed' + (message ? `: ${message}` : ''));
    }
};
export const unreachable = (message) => {
    throw Error('unreachable' + (message ? `: ${message}` : ''));
};
//# sourceMappingURL=todo.js.map